<template>
  <button
    :id="`${id}`"
    :style="{
      '--btn-width': btnWidth + 'px',
      '--btn-height': btnHeight + 'px',
    }"
    class="custom-add-button"
    @click="$emit('action:click')"
  >
    <component
      :is="icon"
      :style="{ '--color': color }"
      class="custom-add-button--icon"
    />
    <span :style="{ '--color': color }" class="custom-add-button--text">{{
      text
    }}</span>
  </button>
</template>
<script>
import { CvIconButton } from '@carbon/vue';

export default {
  components: {
    CvIconButton,
  },
  props: {
    text: {
      type: String,
      required: false,
      default: '',
    },
    color: {
      type: String,
      required: false,
      default: '#161616',
    },
    id: {
      type: String,
      required: false,
      default: '',
    },
    btnWidth: {
      type: Number,
      required: false,
      default: 50,
    },
    btnHeight: {
      type: Number,
      required: false,
      default: 50,
    },
    icon: {
      type: Object,
      required: true,
    },
  },
};
</script>
<style lang="scss" scoped>
.custom-add-button {
  width: var(--btn-width);
  height: var(--btn-height);
  background-color: white;
  border: 1px solid #e0e0e0;
  border-radius: 5px;
  display: grid;
  justify-content: center;
  justify-items: center;
  align-content: space-evenly;

  &--icon {
    width: 35px;
    height: 35px;
    color: var(--color);
  }

  &--text {
    color: var(--color);
  }
}

.custom-add-button:hover {
  cursor: pointer;
}
</style>
